import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ClickOutside from "vue-click-outside";
import { mapActions, mapGetters } from "vuex";
import TransferClientProfileModal from "../../../../modals/transfer-client-profile-modal";
import InlinePrompt from "@Shared/components/general/inline-prompt";
import { UPDATE_CLIENT_PROFILE_COLOR, MARK_CLIENT_PROFILE_INACTIVE } from "@Broker/@Modules/clients/board/store/board-actions";
import { BOARDS, SELECTED_BOARD } from "@Broker/@Modules/clients/board/store/board-getters";
import { showBModal } from "@Shared/components/bootstrap/BModal";
import { defaultAssignableColors } from "@Shared/utils/utils";
import { trim } from "lodash";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "ProfileCardSettings",
  components: {
    InlinePrompt,
    TransferClientProfileModal
  },
  directives: {
    ClickOutside
  },
  props: {
    clientProfileId: {
      type: [String, Number],
      required: true
    },
    clientProfileName: {
      type: String,
      required: true
    },
    statusLabelId: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      resetColor: "#FFFFFF",
      movingToInactive: false,
      clickOutsideNonce: 0
    };
  },
  computed: _objectSpread(_objectSpread({}, mapGetters("BoardStore", [BOARDS, SELECTED_BOARD])), {}, {
    boardsWithoutCurrent() {
      var _context;
      return _filterInstanceProperty(_context = this.BOARDS).call(_context, ({
        id
      }) => id !== this.SELECTED_BOARD.id);
    },
    currentColours() {
      const bodyStyles = window.getComputedStyle(document.body);
      const primary = trim(bodyStyles.getPropertyValue("--primary"));
      const secondary = trim(bodyStyles.getPropertyValue("--secondary"));
      const primaryAlt = trim(bodyStyles.getPropertyValue("--primary-alt"));
      const primaryRGB = trim(bodyStyles.getPropertyValue("--primary-rgb"));
      const primaryClear = trim(bodyStyles.getPropertyValue("--primary-clear"));
      return {
        primary,
        secondary,
        primaryAlt,
        primaryRGB,
        primaryClear
      };
    },
    primaryColor() {
      return this.currentColours.primary;
    },
    secondaryColor() {
      return this.currentColours.secondary;
    },
    markInactiveClass() {
      return `mark-inactive small  ${this.movingToInactive ? "disabled" : "red-action clickable"}`;
    }
  }),
  beforeDestroy() {
    $(this.$refs.colorpicker).off("colorpickerChange", this.handleColorPick);
  },
  mounted() {
    this.initColorPicker();
  },
  methods: _objectSpread(_objectSpread({}, mapActions("BoardStore", [UPDATE_CLIENT_PROFILE_COLOR, MARK_CLIENT_PROFILE_INACTIVE])), {}, {
    initColorPicker() {
      $(this.$refs.colorPicker).colorpicker({
        inline: true,
        format: "hex",
        extensions: [{
          name: "swatches",
          options: {
            colors: defaultAssignableColors(),
            namesAsValues: true
          }
        }],
        fallbackColor: "none"
      }).on("colorpickerChange", this.handleColorPick.bind(this));
    },
    handleColorPick(event) {
      const {
        clientProfileId,
        resetColor
      } = this;
      const color = event.color.toString();
      this.UPDATE_CLIENT_PROFILE_COLOR({
        clientProfileId: clientProfileId,
        cardColour: color === resetColor ? null : color
      });
    },
    async handleMarkAsInactive() {
      this.movingToInactive = true;
      await this.MARK_CLIENT_PROFILE_INACTIVE({
        clientProfileId: this.clientProfileId
      });
      this.movingToInactive = false;
    },
    handleClickOutside() {
      if (this.$refs.transferClientProfileModal.modalOpened) return;
      this.clickOutsideNonce++;
      if (this.clickOutsideNonce > 1) {
        this.clickOutsideNonce = 0;
        this.$emit("hide");
      }
    },
    showAddActivityNoteModal() {
      showBModal("add-activity-note-modal", {
        clientProfileId: this.clientProfileId
      }, this);
    },
    showTransferClientModal() {
      showBModal("transfer-client-modal", {}, this);
    }
  })
});